import { render, staticRenderFns } from "./NotaExame-Admin-anterior.vue?vue&type=template&id=1a9be5f8&"
import script from "./NotaExame-Admin-anterior.vue?vue&type=script&lang=js&"
export * from "./NotaExame-Admin-anterior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports